module.exports = __webpack_public_path__ + "static/2-a08279966575fdfd0440eb08c584f262.jpg";